import { moveToFulfilled, moveToPending, moveToRejected, remove } from '@ms/yammer-data-support';
import type { TopicSubscriptionNotificationTarget } from '@ms/yammer-graphql';
import type { Reducer } from 'redux';

import type { FollowTopicAction, UnfollowTopicAction } from '../../domains/topicFollow/actions.types';
import type { TopicHeaderLoadAction } from '../../domains/topicHeaderLoad/actions.types';
import type { SubscribeTopicAction, UnsubscribeTopicAction } from '../../domains/topicSubscription/actions.types';
import type { TopicCreateFulfilledAction } from '../../domains/topics/createActions.types';
import type { TopicEditAction } from '../../domains/topics/editActions.types';
import type { RemoveTopicFulfilledProps } from '../../domains/topics/removeTopicActions';
import type { RemoveTopicFulfilledAction } from '../../domains/topics/removeTopicActions.types';
import type { TypeaheadFulfilledAction } from '../../domains/typeahead/actions.types';
import type { Topic } from '../types';

import type { TopicNotificationSubscription, TopicNotificationSubscriptions } from './types';
export type TopicNotificationSubscriptionAction =
  | FollowTopicAction
  | TopicHeaderLoadAction
  | UnfollowTopicAction
  | TopicEditAction
  | TopicCreateFulfilledAction
  | TypeaheadFulfilledAction
  | RemoveTopicFulfilledAction
  | SubscribeTopicAction
  | UnsubscribeTopicAction;
const initialState: TopicNotificationSubscriptions = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};
const subscribeTopics = (state: TopicNotificationSubscriptions, topicIds: Topic['id'][]) => {
  const entities: Record<Topic['id'], TopicNotificationSubscription> = {};
  const viewerNotificationSubscriptions: TopicSubscriptionNotificationTarget[] = ['TEAMS', 'IN_APP'];
  topicIds.forEach((topicId) => {
    // eslint-disable-next-line functional/immutable-data
    entities[topicId] = {
      id: topicId,
      viewerNotificationSubscriptions,
    };
  });

  return moveToFulfilled(state, entities);
};
const removeTopic = (state: TopicNotificationSubscriptions, topicIds: RemoveTopicFulfilledProps) => {
  const curatedTopicId = topicIds?.curatedTopicId;

  return curatedTopicId ? remove(state, [curatedTopicId]) : state;
};
const reducer: Reducer<TopicNotificationSubscriptions, TopicNotificationSubscriptionAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'TOPIC_HEADER.LOAD_PENDING':
      return moveToPending(state, [action.payload.topicId]);
    case 'TOPIC_HEADER.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.topicId], action.payload.error);
    case 'TOPIC_HEADER.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.topicNotificationSubscriptions);
    case 'TOPIC.CREATE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.topicNotificationSubscriptions);
    case 'TYPEAHEAD.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.topicNotificationSubscriptions);
    case 'TOPIC.REMOVE_FULFILLED':
      return removeTopic(state, action.payload);
    case 'TOPIC.SUBSCRIBE_FULFILLED':
      return subscribeTopics(state, action.payload.topicIds);
    case 'TOPIC.UNSUBSCRIBE_FULFILLED':
      return remove(state, action.payload.topicIds);
    default:
      return state;
  }
};
export default reducer;
